import { environment } from '@env/environment';

export function logMsg(klass: { name: string }, msg: string): void {
  if (environment.debugMode) {
    console.log(`[${klass.name}] ${msg}`);
  }
}
